export class TranscriptRequestOptions {
    
    constructor(data: Partial<TranscriptRequestOptions>) {
        Object.assign(this, data);
    }

    mergeUtts: boolean;
    reconstructUtts: boolean;
}